module.exports = __webpack_public_path__ + "img/intraPersonal1.94945282.png";